/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesAgentPreSignedUrlResponse {
    getFixupPrototypeFunction() { return KubernetesAgentPreSignedUrlResponse.fixupPrototype; }

    static newInstance(model: Partial<KubernetesAgentPreSignedUrlResponse>): KubernetesAgentPreSignedUrlResponse {
        let obj = Object.assign(new KubernetesAgentPreSignedUrlResponse(), model);
        KubernetesAgentPreSignedUrlResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesAgentPreSignedUrlResponse>): KubernetesAgentPreSignedUrlResponse {
        if (!model) return null;
        return KubernetesAgentPreSignedUrlResponse.newInstance(<KubernetesAgentPreSignedUrlResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesAgentPreSignedUrlResponse) {
        if (!obj) return;

        models.KubernetesAgentPreSignedUrlResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesAgentPreSignedUrlResponse): boolean {
        Object.setPrototypeOf(obj, KubernetesAgentPreSignedUrlResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.signed_url_details) {
            for (let val of this.signed_url_details) {
                models.SignedUrlDetails.fixupPrototype(val);
            }
        }
    }

    signed_url_details: Array<models.SignedUrlDetails>;

}
